import { http } from './http';

export interface ApiDrawerMyPermissions {
  CanCreate?: boolean;
  CanRead?: boolean;
  CanUpdate?: boolean;
  CanDelete?: boolean;

  // tolerate camelCase if a different serializer is used
  canCreate?: boolean;
  canRead?: boolean;
  canUpdate?: boolean;
  canDelete?: boolean;
}

export async function getMyDrawerPermissions(drawerId: number): Promise<ApiDrawerMyPermissions> {
  return http<ApiDrawerMyPermissions>(`/api/drawer/${drawerId}/mypermissions`);
}

export async function canCreateInDrawer(drawerId: number): Promise<boolean> {
  const p = await getMyDrawerPermissions(drawerId);
  return Boolean(p?.CanCreate ?? p?.canCreate);
}
